import JobList from "@/components/Jobs/JobList.vue";
import JobEdit from "@/components/Jobs/JobEdit.vue";
import JobFilter from "@/components/Jobs/JobFilter.vue";
import JobHeader from "@/components/Jobs/JobHeader.vue";

export default [
    {
        path: 'job',
        alias: ['jobs', 'requests', 'request'],
        name: 'All Jobs',
        redirect: "/job/list",
        components: {
            page: JobList,
            header: JobHeader,
        },
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: "filter",
                name: "Job Filter",
                components: {
                    modal: JobFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Job List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "edit/:id",
                name: "Job Edit",
                components: {
                    modal: JobEdit,
                }
            }
        ]
    }
];